// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Options/FieldOptions.proto (syntax proto3)
/* eslint-disable */

import type { GenExtension, GenFile } from "@bufbuild/protobuf/codegenv2";
import { extDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file Options/FieldOptions.proto.
 */
export const file_Options_FieldOptions: GenFile = /*@__PURE__*/
  fileDesc("ChpPcHRpb25zL0ZpZWxkT3B0aW9ucy5wcm90bzpSChRkZWZhdWx0X3N0cmluZ192YWx1ZRIdLmdvb2dsZS5wcm90b2J1Zi5GaWVsZE9wdGlvbnMY3Nn5ASABKAlSEmRlZmF1bHRTdHJpbmdWYWx1ZUIkqgIhTW9naS5UaW1lVHJhY2tpbmcuQ29tbW9uLk1lc3NhZ2VzYgZwcm90bzM", [file_google_protobuf_descriptor]);

/**
 * Adds a default value to a string field.
 *
 * @generated from extension: string default_string_value = 4091100;
 */
export const default_string_value: GenExtension<FieldOptions, string> = /*@__PURE__*/
  extDesc(file_Options_FieldOptions, 0);

